import { instanceBo } from "../utils/axios.create";
import { IAlertEvent } from "@/domain/alertEvent.interface";

// Epic SIMS-6464: the Alert Events domain runs on backend-v2 — SIMS-6546 migrated the list
// read and SIMS-6550 the dismiss, so both calls go through instanceBo. The v1 axios instance
// is no longer used by this service.
const getAll = async (userId: string): Promise<IAlertEvent[]> => {
	return instanceBo
		.get(`/alert-events-list/${userId}`)
		.then((res) => {
			return res.data.body;
		})
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

const putAlertEvent = async (
	providerId: string,
	alertId?: string,
): Promise<{
	acknowledged: boolean;
	modifiedCount: number;
	upsertedId: number | undefined;
	upsertedCount: number;
	matchedCount: number;
}> => {
	const url = `/alert-events/${providerId}${alertId ? `?alertId=${alertId}` : ""}`;

	return instanceBo
		.put(url)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

export const alertEventService = {
	getAll,
	putAlertEvent,
};
